export interface Users {
	UserId: number;
	UserName: string;
	Password: string;
	Admin: string;
	Logged: string;
	AgentID: string;
	AgentPassword: string;
	AgentEmail: string;
	AgentPhoneMobile: string;
	AgentExtra1: string;
	AgentExtra2: string;
	AgentWarehouse: string;
}

export interface LoginUser {
	UserId: number;
	UserName: string;
	Password: string;
	Admin: string;
	Logged: string;
	AgentID: string;
	AgentPassword: string;
	AgentEmail: string;
	CustNum: string;
	AgentPhoneMobile: string;
	AgentExtra1: string;
	AgentExtra2: string;
	AgentWarehouse: string;
	HasMainGroup: number;
	AddProduct: number;
	IsHistFirst: number;
	ordon: number;
	hazaon: number;
	reton: number;
	ShowProfit: number;
	IgnorMinPrice: number;
	Email?: string;
}

export interface Submanagers {
	AdminAgent: string;
	Agent: string;
}

export type AdminTypes =
	| 'true'
	| 'false'
	| 'b2b'
	| 'b2bL'
	| 'b2bLM'
	| 'b2bM'
	| 'simple'
	| 'dashboard'
	| 'password'
	| 'melaket'
	| 'checker'
	| 'checkerM'
	| 'Catalog'
	| 'Mekabel'
	| 'b2bei'
	| 'b2bnh'
	| 'b2bp';

export const adminToHebrewName = {
	true: 'מנהל',
	false: 'סוכן',
	b2b: 'B2B',
	b2bL: 'B2B ליסינג',
	b2bLM: 'B2B ליסינג מנהל',
	b2bM: 'B2B מנהל',
	simple: 'פשוט',
	dashboard: 'תמונת מצב',
	password: 'סיסמא',
	melaket: 'מלקט',
	checker: 'בודק',
	checkerM: 'בודק',
	Catalog: 'קטלוג',
	Mekabel: 'מקבל',
	b2bei: 'B2B איתנס',
	b2bnh: 'B2B ניצני הדר',
	b2bp: 'B2B',
};

export const ReportsManagementCanSeeDictionary = {
	dashboardTwo: '1',
	receiptManagement: '2',
	adminBizoaHevra: '3',
	dohotLekohotHovotAdmin: '4',
} as const;
// export type ReportsManagementCanSee = typeof ReportsManagementCanSeeDictionary[keyof typeof ReportsManagementCanSeeDictionary];
export type ReportsManagementCanSeeKeys = keyof typeof ReportsManagementCanSeeDictionary;
export type ReportsManagementCanSeeValues = typeof ReportsManagementCanSeeDictionary[ReportsManagementCanSeeKeys];
